import { Component , EventEmitter , Output , Input , OnChanges, SimpleChanges , OnInit} from '@angular/core';
import { FastAPIService, Solver } from 'src/app/service/fast-api.service';

@Component({
  selector: 'app-nlp-example',
  templateUrl: './nlp-example.component.html',
  styleUrls: ['./nlp-example.component.scss']
})
export class NlpExampleComponent implements OnChanges, OnInit{
  @Output() exampleClick:EventEmitter<ExampleItem> = new EventEmitter<ExampleItem>();
  @Input() receivedData: ExampleItem | null = {date: null, text: null};
  example_data: ExampleItem[] = [];

  constructor(private service: FastAPIService) {}

  filter: string = "";
  ngOnInit(): void {
      this.fetchHistory();
      this.filter = new Solver().solve().filter;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['receivedData'] && !changes['receivedData'].firstChange) {
      const newData = changes['receivedData'].currentValue;
      this.setExample(newData);
    }
  }

  emitExample(data:ExampleItem) {
    this.exampleClick.emit(data);
  }

  setExample(data:ExampleItem) {
    const newItem: ExampleItem = {
      date: data.date,
      text: data.text
    };
    this.example_data.unshift(newItem);
  }

  convertDate(date: Date | null) {
    if (date == null) {
      return
    }
    const formattedDate = new Intl.DateTimeFormat('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }).format(date);
    const today = new Date();
    if (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    ) {
      return 'Today';
    }
  
    return formattedDate;
  }

  decideShowDate(item: ExampleItem, index: number): boolean {
    if (index === 0) {
      return true;
    } else {
      const formattedDate = this.convertDate(item.date);
      const prevFormattedDated = this.convertDate(this.example_data[index-1].date);
      if (formattedDate == prevFormattedDated) {
        return false;
      } 
      else {
        return true;
      }
    }
  }

  clearAll() {
    this.example_data = [];
  }

  fetchHistory() {
    const index:number = 6;
    this.service.getHistoryById(0,index).subscribe((data) => {
      data.data.map((i:any) => {
        const newItem: ExampleItem = {
          date: new Date(i.createdAt),
          text: i.question
        };
        if (index == -1) {
          this.example_data.unshift(newItem);
        } else {
          this.example_data.push(newItem);
        }
        
      })
    })
  }

}

export interface ExampleItem {
  date: Date | null;
  text: string | null;
}
